import { render, staticRenderFns } from "./pinnedMessage.vue?vue&type=template&id=71d775d0&scoped=true&"
import script from "./pinnedMessage.vue?vue&type=script&lang=js&"
export * from "./pinnedMessage.vue?vue&type=script&lang=js&"
import style0 from "./pinnedMessage.vue?vue&type=style&index=0&id=71d775d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d775d0",
  null
  
)

export default component.exports